module.exports = __webpack_public_path__ + "static/secondMovementBeginning-9328827058c2620ddb55b9ff4c1375e5.mp3";